export default {
  lang: {
    zh: 'Chinese',
    en: 'English',
    ko: 'Korean'
  },
  // logo: require('@/assets/images/icon/logoen.png'),
  footer: {
    title: 'Copyright © 2020 guangdong chaobohui business exhibition co., LTD. All rights reserved',
    contact: 'Contact Us',
    address: 'Company Address',
    wechat: 'WeChat Public Account',
    address_detail: 'Chengjiang road and yutan road, chenghai district, shantou city, guangdong province'
  },
  tab: {
    home: 'operation',
    statistics: 'statistics',
    mine: 'me'
  },
  menu: {
    home: 'Arctic Dolphin',
    contact: 'Contact us',
    help: 'Help',
    setting: 'Settings',
    favorite: 'My favorite',
    message: 'Notice',
    information: 'Profile',
    mine: 'Mine',
    history: 'Device history',
    setup: 'Setting',
    feedback: 'Feedback',
    manual: 'User manual',
    site: 'Recovery site'
  },
  title: {
    message: 'Message Center',
    clientInfo: 'My Client',
    quotation: 'My Quotation',
    customerBill: 'Customer Bill',
    recentlySample: 'Recent Product Order',
    recommendedQuotation: 'Product Order',
    recommendedQuotationNum: 'Product Order Number',
    confirmQuotation: 'Confirm Quotation',
    confirmQuotationNum: 'Product Order Number',
    unquotedSample: 'Confirm Product',
    selectedSample: 'Selected Product',
    copySample: 'Copying Product Order',
    preview: 'Preview'
  },
  loading: 'loading...',
  button: {
    returnHome: 'Return home',
    returnPrev: 'Reurn previous',
    addClient: 'Add client',
    addQuotation: 'Add quotation',
    copyQuotation: 'Copy quotation',
    unfreeze: 'unfreeze',
    freeze: 'freeze',
    search: 'Search',
    reset: 'Reset',
    edit: 'Edit',
    setPassword: 'Set password',
    recommend: 'Recommend',
    detail: 'Detail',
    quote_detail: 'Quote detail',
    confirmRecommend: 'Confirm recommend',
    filter: 'Filter',
    delete: 'Delete',
    exportExcel: 'Export Excel',
    exportQuotation: 'Export Excel',
    printQuotation: 'Print product order',
    checkOrder: 'Check confirm order',
    joinAll: 'Jion all',
    addConfirm: 'Addconfim',
    more: 'More',
    chooseTheSample: 'Choose the sample',
    cancel: 'Cancel',
    confirm: 'Confirm',
    askQuotation: 'Request a quote',
    setQuote: 'Set quote',
    checkQuote: 'Check quote',
    check: 'Check Product',
    online: 'Online Service',
    backTop: 'Back Top',
    time: 'Online Time'
  },
  placeholder: {
    email: 'Please enter your email',
    verifiy: 'Enter the verification code',
    password: 'Enter the password',
    newPassword: 'Enter a new password',
    confirmPassword: 'Enter the new password again'
  },
  select: {
    all: 'all',
    unconfirmed: 'unconfirmed',
    confirmed: 'confirmed',
    chooseTheSampleNumber: 'product order number',
    customer: 'customer',
    code: 'code',
    sampleCode: 'product number',
    sampleInfo: 'product name',
    category: 'Category',
    price: 'Price',
    filter: 'Filters'
  },
  tips: {
    title: 'Tips',
    content: 'Please use Google Chrome or 360 browser with higher compatibility',
    login: 'login...',
    deleteFirst: 'Confirm to delete these',
    deleteSecond: 'Kinds of products',
    empty: 'No products can be submitted',
    deleteTitle: 'Tips',
    deleteMessage: 'Confirm to delete?',
    noMore: 'No More'
  },
  message: {
    phone: 'Please enter your phone number',
    email: 'Please enter your E-mail',
    isPhone: 'The input is not valid phone number',
    isEmail: 'The input is not valid E-mail',
    account: 'Please enter your account number',
    verifiy: 'Please enter the verification code',
    password: 'Please enter your password',
    setPassword: 'Please set password',
    key: 'Please enter the activation code',
    oldPassword: 'Please enter your old password',
    newPassword: 'Please enter your new password',
    confirmPassword: 'Please confirm your new password',
    noData: 'No data',
    sendPhone: 'Successfully sent, please check in the SMS',
    sendEmail: 'Successfully sent, please check in the E-mail',
    getCode: 'Please obtain the verification code',
    401: '~You do not have permission to browse~',
    404: '~The relevant page could not be found~',
    500: '~The server crashed~',
    client: {
      account: 'Please enter the client account',
      nickName: 'Please enter the client nickName',
      password: 'Please enter the client password'
    }
  },
  link: {
  },
  table: {
    client: {
      index: 'No.',
      account: 'Account',
      nickName: 'Nick Name',
      status: 'Condition',
      operation: 'Operation',
      copyLink: 'CopyLink',
      checkLink: 'Check'
    },
    quotation: {
      quotationNum: 'Product Order Number',
      sectionNum: 'Quantity',
      quotationTime: 'Date',
      company: 'Company',
      customer: 'Customer',
      status: 'Condition',
      customerStatus: 'Condition',
      remark: 'Remark',
      reply: 'Reply',
      operation: 'Operation',
      picture: 'Picture',
      code: 'Code',
      product: 'Product Name',
      productCode: 'Item No',
      specifications: 'Product Size',
      packSpecifications: 'Packing Size',
      cartonSpecifications: 'Carton Size',
      outerBoxContent: 'Carton Quantity',
      innerBoxQuantity: 'Inner Boxes',
      cuft: 'Cubic Feet',
      volume: 'Volume',
      package: 'Packing',
      weight: 'G.W/N.W',
      venderName: 'Vender Name',
      venderContact: 'Vender Contact',
      venderTel: 'Vender Tel',
      venderPhone: 'Vender Phone',
      price: 'Price',
      sPrice: 'Price',
      clPrice: 'Client Price',
      boxes: 'Boxes'
    }
  },
  status: {
    unfreeze: 'unfreeze',
    freeze: 'freeze',
    confirmed: 'confirmed',
    unconfirmed: 'unconfirmed',
    recommended: 'recommended',
    notRecommended: 'not recommended',
    replied: 'replied',
    pendingReply: 'pending reply',
    notRequested: 'not requested',
    quoted: 'quoted',
    pendingQuotation: 'pending quotation'
  },
  form: {
    copySample: 'The product order number which you would like to copy to',
    client: {
      account: 'account',
      nickName: 'nickName',
      password: 'password'
    }
  },
  login: {
    client: 'Login',
    title: 'Login/Register',
    phone: 'Phone',
    account: 'Account',
    email: 'Email',
    login: 'Sign Me In',
    company_login: 'Company login',
    client_login: 'Client login',
    get_auth_code: 'GetAuthCode',
    free_register: 'Free register',
    accomplish: 'Login',
    auth_code: 'Code',
    password: 'Password',
    welcome: 'Welcome',
    logout: 'Logout',
    phoneLogin: 'Phone quick login'
  },
  register: {
    title: 'Register account',
    companyZhName: 'Company Name',
    companyEnName: 'Company En Name',
    companyAddress: 'Company Address',
    linkman: 'Linkman',
    phoneNumber: 'Phone Number',
    department: 'Department',
    businessLicense: 'Business License',
    register: 'Register',
    backLogin: 'Back login',
    telephone: 'Telephone',
    forget: 'Change password',
    confirm: 'Confirm',
    login: 'Log in',
    switch: 'Switch account',
    logout: 'Logout'
  },
  home: {
    hot_type: 'Hot type',
    new_product: 'We recommend the latest products to you',
    modify: 'Modify'
  },
  basicInfo: {
    title: 'Basic info'
  },
  news: {
    title: 'News information'
  },
  product: {
    all: 'All',
    continue: 'Continue to add',
    back: 'Back to add',
    quote: 'Choose product',
    whether_add: 'Has joined',
    title: 'Product Center',
    category: 'Category',
    choose_category: 'Choose category',
    placeholder: 'Name',
    sample_center: 'Product Center',
    guess_you_like: 'Guess you like',
    item_no: 'Item No',
    product_standard: 'Product Size',
    carton_specifications: 'Carton Size',
    pack_specifications: 'Packing Size',
    inside_box: 'Inner Boxes',
    quantity: 'quantity',
    picking: 'packing',
    gw: 'G.W',
    nw: 'N.W',
    cuft: 'Cubic Feet',
    volume: 'Volume',
    credentials: 'Credentials',
    choose_sample: 'Choose product',
    add_choose_sample: 'Add  Choose  product',
    delete: 'Delete',
    confirm: 'Confirm',
    success_add: 'Successfully add choose product',
    add_sample: 'Add product',
    close: 'close',
    view_sample: 'View product',
    name: 'Product name',
    code: 'Code',
    price: 'Price',
    mode: 'Displaying mode',
    thumbnail: 'Thumbnail',
    list: 'List',
    updateTime: 'Update Time',
    integratedQuery: 'Integrated Query',
    highToLow: 'Price from high to low',
    lowToHigh: 'Price from low to high',
    priceRange: 'Price Range',
    determine: 'Confirm',
    edit: 'Edit',
    finsh: 'Finsh',
    params: 'Details'
  },
  label: {
    productName: 'Product Name',
    productCode: 'Product Code',
    code: 'Code',
    packageWay: 'Packing',
    qty: 'QTY',
    cartonLength: 'Carton Length',
    cartonWidth: 'Carton Width',
    cartonHeight: 'Carton Height',
    packageLength: 'Package Length',
    packageWidth: 'Package Width',
    packageHeight: 'Package Height',
    gw: 'GW',
    nw: 'NW',
    approve: 'Credentials',
    price: 'Price'
  }
}
